import { http } from '@/shared/api/axios'

export async function completeOnboarding(): Promise<void> {
  await http.post('/v1/me/onboarding/complete')
}
